import { RefObject, useEffect, useState } from 'react';

const useVisibleOnScreen = (ref: RefObject<HTMLElement>) => {
  const [isVisible, setIsVisible] = useState(false);

  const checkVisible = () => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    if (rect.top < window.innerHeight * 1.5) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    checkVisible();
    window.addEventListener('scroll', checkVisible);
    window.addEventListener('resize', checkVisible);
    return () => {
      window.removeEventListener('scroll', checkVisible);
      window.removeEventListener('resize', checkVisible);
    };
  }, []);

  return { isVisible };
};

export default useVisibleOnScreen;
